import { useEffect, useState } from "react";

/* -------- packages -------- */
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import {
  Col,
  Card,
  CardBody
} from "reactstrap";
/* -------- ------- -------- */

/* -------- components -------- */
import menuItems from "../../../utils/menuItems";
/* -------- ------- -------- */

export default function TotalKpi ({label, rightName, iconClass, description, disposition}) {
    const { t } = useTranslation()

    // search for a already existing icon in the menu / if false will return undefined and will be handled in the component (iconClass)
    const iconClassFormMenu = menuItems.find((item) => item.rightName === rightName)?.icon;


    return  (
        <Col key={"_col_kpi_" + label} className={"kpiComponent " + (disposition ? disposition : " col-12 col-md-6 col-xl-3")} >
          <Card>
            <CardBody>
                <div className="kpiContent">
                  <div className="kpiIcon">
                    {   iconClass ?
                        <i className={iconClass}></i>
                        :
                        <i className={iconClassFormMenu}></i>
                    }
                  </div>
                  <div className="flex-grow-1 ms-3 me-2">
                    <p>{t(label)}</p>
                  </div>
                  <div className="flex-grow-1 ms-3 me-2 dataInfo">
                      <p className="listLength">{description}</p>
                  </div>
                </div>
            </CardBody>
          </Card>
        </Col>
    )
}